import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OrchestrationAssistantState } from '../reducers/orchestration-assistant.reducer';

export const getOrchestrationAssistantState = createFeatureSelector<OrchestrationAssistantState>('orchestrationAssistant');

export const getOrchestrationSessionId$ = createSelector(getOrchestrationAssistantState, state => state?.session_id);

export const getOrchestrationMessages$ = createSelector(getOrchestrationAssistantState, state => state?.messages || []);

export const getOrchestrationLoading$ = createSelector(getOrchestrationAssistantState, state => state?.loading || false);

export const getOrchestrationError$ = createSelector(getOrchestrationAssistantState, state => state?.error);

export const getOrchestrationSessions$ = createSelector(getOrchestrationAssistantState, state => state?.sessions || []);
